var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavUnderline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 141,
  height: 8,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.424.627 0 4.197 5.403 7.54l15.502-.03 12.477-.346 12.477.587 12.477-.632 12.476.693 12.477-.347H95.8l12.477-.09 12.51.361 17.963-.391L140.165 4 135 .823 121.881.778l-11.415.015L99.051.567H87.636L76.221.31 64.806.235 53.391.22 41.976.913 30.562.326 19.147.702 7.698.16z"
})));
export default SvgNavUnderline;